import { useCallback } from 'react';

import { createAtlAttributionHeader } from '../../../common/fetch/atl-attribution-header';
import { fetchAggResponse } from '../../../common/fetch/fetch-agg-response';
import {
	type ToggleDefinitionFunctionType,
	ToggleDefinitionMutation,
	type ToggleDefinitionMutationType,
	type ToggleDefinitionMutationVariables,
} from '../gql/toggle-definition-mutation';

type ToggleDefinitionSupplierType = {
	toggleDefinition: ToggleDefinitionFunctionType;
};

export const useToggleDefinitionSupplier = (): ToggleDefinitionSupplierType => {
	const toggleDefinition = useCallback(
		async ({
			workspaceId,
			keyPhrase,
			isDisabled,
			cloudId,
			product,
		}: ToggleDefinitionMutationVariables & { cloudId: string; product: string }) => {
			return fetchAggResponse<ToggleDefinitionMutationVariables, ToggleDefinitionMutationType>({
				graphQuery: ToggleDefinitionMutation,
				variables: {
					workspaceId,
					keyPhrase,
					isDisabled,
				},
				headers: createAtlAttributionHeader({
					atlWorkspaceId: workspaceId,
					tenantId: cloudId,
					product,
				}),
			}).then((response) => {
				if (response?.data?.knowledgeDiscovery.updateUserKeyPhraseInteraction?.success) {
					return {
						toggleDefinitionSuccess: true,
					};
				} else {
					throw new Error('toggleDefinition mutation unsuccessful');
				}
			});
		},
		[],
	);

	return { toggleDefinition };
};
